import ParentEdit from '@/controllers/parent/parent-edit.js';

export default {
  extends: ParentEdit,
}
